import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Suspense } from "react";
import { getSessionData } from "../../utils/interceptors/localStorageService";
import LoadingPage from "../../shared/common/Loader";
import UltimateAgentLayout from "../../pages/UltimateAgent/layout/UltimateAgentLayout";
import { savePendingEntityProcessorRoute } from "../helper/entityProcessorRedirect";

/**
 * Wraps UltimateAgent routes with auth guard and the dedicated UA sidebar layout.
 * Bypasses InnerLayout so the UA module gets its own full-screen navigation.
 */
const UltimateAgentProtectedLayout = () => {
  const sessionData = getSessionData();
  const location = useLocation();
  const isRegistrationRoute =
    location.pathname.startsWith("/ultimate-agent/register") ||
    location.pathname.startsWith("/ultimate-agent/invite/");

  if (isRegistrationRoute) {
    return (
      <Suspense fallback={<LoadingPage />}>
        <Outlet />
      </Suspense>
    );
  }

  if (!sessionData) {
    if (location.pathname === "/ultimate-agent" || location.pathname === "/ultimate-agent/") {
      return <Navigate to="/ultimate-agent/register" state={{ from: location }} replace />;
    }
    savePendingEntityProcessorRoute(
      `${location.pathname}${location.search}${location.hash}`,
    );
    return <Navigate to="/authentication/login" state={{ from: location }} replace />;
  }

  return (
    <Suspense fallback={<LoadingPage />}>
      <UltimateAgentLayout />
    </Suspense>
  );
};

export default UltimateAgentProtectedLayout;
